import { styled } from '@mui/material/styles';
import { Paper, Typography, TableRow, Box, TextField, Chip, alpha } from '@mui/material';

// Section Paper with gradient background
export const SectionPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  padding: theme.spacing(4),
  position: 'relative',
  borderRadius: 16,
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.02)})`,
  border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
  boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.15)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  animation: 'slideInUp 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '@keyframes slideInUp': {
    '0%': {
      transform: 'translateY(100%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateY(0)',
      opacity: 1,
    }
  },
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.25)}`
  }
}));

// Section Title with icon styling
export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  marginBottom: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  fontSize: '1.2rem',
  color: theme.palette.primary.main,
  letterSpacing: '-0.3px',
  '& .MuiSvgIcon-root': {
    marginRight: theme.spacing(2),
    fontSize: 28,
    background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    color: 'white',
    borderRadius: 8,
    padding: theme.spacing(1),
    border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
    boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.25)}`
  }
}));

// Status chip with dynamic colors
export const StatusChip = styled(Chip)(({ theme, status }) => {
  let color = 'default';
  switch (status) {
    case 'delivered':
    case 'in_transit':
      color = 'success';
      break;
    case 'pending':
    case 'scheduled':
      color = 'warning';
      break;
    case 'cancelled':
    case 'delayed':
      color = 'error';
      break;
    case 'processing':
      color = 'info';
      break;
    default:
      color = 'default';
  }
  return {
    fontWeight: 500,
    borderRadius: 8,
    textTransform: 'uppercase',
    fontSize: '0.7rem',
    minWidth: 80,
    border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
    backgroundColor: color === 'default' ? theme.palette.grey[100] : alpha(theme.palette[color].main, 0.1),
    color: color === 'default' ? theme.palette.text.primary : theme.palette[color].main,
  };
});

// Number input with right alignment
export const NumberTextField = styled(TextField)(({ theme }) => ({
  '& input': {
    textAlign: 'right',
    paddingRight: theme.spacing(1),
    fontWeight: 500,
    fontSize: '0.9rem',
  },
  width: '100%',
  '& .MuiInputBase-root': {
    borderRadius: 8,
    border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
    background: 'white',
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused fieldset': {
      border: 'none'
    },
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`
    },
    '&.Mui-focused': {
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.25)}`
    }
  }
}));